/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { OwnersControllerRemoveMutationResponse, OwnersControllerRemovePathParams, OwnersControllerRemove401, OwnersControllerRemove403, OwnersControllerRemove404 } from "../../models/ownersController/OwnersControllerRemove";

function getOwnersControllerRemoveUrl(id: OwnersControllerRemovePathParams["id"]) {
  const res = { method: 'DELETE', url: `/api/v1/owners/${id}` as const }  
  return res
}

/**
 * @summary Delete an owner
 * {@link /api/v1/owners/:id}
 */
export async function ownersControllerRemove(id: OwnersControllerRemovePathParams["id"], config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<OwnersControllerRemoveMutationResponse, ResponseErrorConfig<OwnersControllerRemove401 | OwnersControllerRemove403 | OwnersControllerRemove404>, unknown>({ method : "DELETE", url : getOwnersControllerRemoveUrl(id).url.toString(), ... requestConfig })  
  return res.data
}